import React from 'react';
import { BrowserRouter as Router, Link,  useLocation } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemText, Toolbar} from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import DescriptionIcon from '@mui/icons-material/Description';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import ForumIcon from '@mui/icons-material/Forum';
import SettingsIcon from '@mui/icons-material/Settings';

import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

/**
 * A sidebar component for navigation within the application. It includes links to different sections
 * such as Calendar, Processes, Files, Reports, Messages, and Settings. The sidebar is styled using
 * Material-UI and integrates with React Router for navigation.
 * 
 * @component
 * @example
 * <SideBar />
 * @returns {React.Component} The rendered sidebar component.
 */
const SideBar = () => {
  const drawerWidth = 240;
  const { pathname } = useLocation();
  const [open, setOpen] = React.useState(true);

  return (
      <div style={{ display: 'flex'}}>
        <Drawer
          variant="persistent"
          open={open}
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: {
              width: drawerWidth,
              boxSizing: 'border-box',
              margin: '93px 0 0 10px',
              border: 'solid 1px #cfcfcf',
              borderRadius: '30px',
              height: '86vh',
              boxShadow: '3px 11px 7px -6px rgba(161, 156, 161, 1)'
            },
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              sx={[
                {
                  ml: 'auto',
                },
                !open && { display: 'none' },
              ]}
            >
              <MenuIcon />
            </IconButton>           
          </Toolbar>
          <List>
            {[
              { icon: <CalendarMonthIcon/>, text: 'Calendar', path: '/calendar', disabled: false },
              { icon: <ManageHistoryIcon/>, text: 'Processes', path: '/processes', disabled: false },
              { icon: <DescriptionIcon/>, text: 'Files', path: '/files', disabled: false },
              { icon: <QueryStatsIcon/>, text: 'Reports', path: '/reports', disabled: false },
              { icon: <ForumIcon/>, text: 'Messages', path: '/messages', disabled: false },
              { icon: <SettingsIcon/>, text: 'Settings', path: '/settings', disabled: false },
            ].map((item) => (
              <ListItem 
                button key={item.text} 
                component={Link} 
                to={item.disabled? "#": item.path}
                sx={{
                  color: 'black', 
                  minWidth: 'fit-content',
                  background: item.path === pathname ? "#a9a9a9":""
                }}>
                {item.icon}
                <ListItemText primary={item.text} sx={{marginLeft: "10px"}}/>
              </ListItem>
            ))}
          </List>
        </Drawer>
      </div>
  );
};

export default SideBar;
